import FileDownloadResource from "./fileDownload.resource";

const fileDownloadModule = angular
  .module("app.resources.fileDownload", [])
  .service("FileDownload", FileDownloadResource);

export default fileDownloadModule;



// WEBPACK FOOTER //
// ./src/resources/fileDownload/fileDownload.module.js